import { render, staticRenderFns } from "./FileSystemDragOverlay.vue?vue&type=template&id=33670e0b&scoped=true&"
import script from "./FileSystemDragOverlay.vue?vue&type=script&lang=ts&"
export * from "./FileSystemDragOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystemDragOverlay.vue?vue&type=style&index=0&id=33670e0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33670e0b",
  null
  
)

export default component.exports